module.exports = __webpack_public_path__ + "static/garl_glittergold-symbol-DND3_FnP-94f26ac97e216b17462fac5ba3f95a3a.jpg";